// import Api from "../../service/api";
import { showAlert } from "../alert/alertActions";
import { showLoader, hideLoader } from "../loader/loaderActions";
import {
  resetRedirected,
  resetPageAndLimit,
  resetActiveNavigationTab,
} from "../YouTubeManagement/YouTubeManagementActions";
import { resetBannerScreenFilter } from "../BannerManagement/BannerManagementActions";
import { persistMenuBar } from "../sidebar/sidebarActions";
import {
  setRowReordered,
  setRowReorderWarningModal,
} from "../../store/BannerManagement/BannerManagementActions";
import Api from "./../../service/api";
import { history, getState } from "../configure/configureStore";
import { actionTypes } from "./authReducer";

export function login(email, password, callback) {
  return (dispatch) => {
    let data = {
      email: email,
      password: password,
    };
    if (email === "" || password === "") {
      dispatch(
        showAlert({
          isOpen: true,
          title: "error",
          type: "danger",
          msg: "Fill all the fields.",
        })
      );
    } else {
      dispatch({
        type: actionTypes.AUTH_PENDING,
        payload: {
          authPending: true,
          authSuccess: false,
          authError: null,
          accessToken: null,
          refreshToken: null,
          profileurl: null,
          loginUser: null,
          userRole: null,
          userPermissions: null,
        },
      });
      dispatch(showLoader());

      Api.post("auth/signin", data)
        .then((response) => {
          dispatch(resetRedirected());
          dispatch(resetPageAndLimit());
          dispatch(resetBannerScreenFilter());
          dispatch(setRowReordered(false));
          dispatch(setRowReorderWarningModal(false));
          //
          const data = { users: true, media: false, subScription: false };
          dispatch(persistMenuBar(data));
          // console.log("response", response);
          const permissionList = response?.data?.data?.userPermissions;
          const stringArray = permissionList?.map((item) => item?.displayName);
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.AUTH_SUCCESS,
            payload: {
              authPending: false,
              authSuccess: true,
              authError: null,
              accessToken: response.data.accessToken,
              refreshToken: response.data.refreshToken,
              profileurl: null,
              loginUser: response.data,
              userRole: response.data?.data?.roleId[0]?.role,
              userPermissions: stringArray,
            },
          });
          // dispatch(permissionStringArray(response));
          callback();
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.AUTH_ERROR,
            payload: {
              authPending: false,
              authSuccess: true,
              authError: false,
              accessToken: null,
              refreshToken: null,
              profileurl: null,
              loginUser: null,
              userRole: null,
              userPermissions: null,
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "Error",
              type: "danger",
              // msg: "Enter Valid Credential",
              msg: err.message,
            })
          );
        });
    }
  };
}

function permissionStringArray(response) {
  const permissionList = response?.data?.data?.userPermissions;
  const stringArray = permissionList?.map((item) => item?.displayName);
  // console.log("permission string array", stringArray);
  return (dispatch) => {
    dispatch({
      type: actionTypes.AUTH_SUCCESS,
      payload: {
        userPermissions: stringArray,
      },
    });
  };
}

export function logout() {
  return (dispatch) => {
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + getState().auth.accessToken,
    };

    dispatch({
      type: actionTypes.LOGOUT_PENDING,
      payload: {
        logoutPending: true,
        logoutSuccess: false,
        logoutError: null,
      },
    });
    dispatch(showLoader());
    Api.post(`auth/logout`, {}, headers)
      .then((response) => {
        dispatch(resetRedirected());
        dispatch(resetPageAndLimit());

        // console.log("logout response", response);
        if (response.message) {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.LOGOUT_SUCCESS,
            payload: {
              logoutPending: false,
              logoutSuccess: true,
              logoutError: null,
              accessToken: null,
              refreshToken: null,
              profileurl: null,
              userRole: null,
              loginUser: null,
              userPermissions: null,
            },
          });
          setTimeout(() => {
            console.log("history push", history);
            history.push("/login");
            dispatch(resetActiveNavigationTab());
          }, 500);

          dispatch(
            showAlert({
              isOpen: true,
              title: "Success",
              type: "success",
              msg: response.message,
            })
          );
        } else {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.LOGOUT_SUCCESS,
            payload: {
              logoutPending: false,
              logoutSuccess: true,
              logoutError: null,
              accessToken: null,
              refreshToken: null,
              profileurl: null,
              loginUser: null,
              userRole: null,
              userPermissions: null,
            },
          });
          setTimeout(() => {
            history.push("/login");
            dispatch(resetActiveNavigationTab());
          }, 500);
        }
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.LOGOUT_SUCCESS,
          payload: {
            logoutPending: false,
            logoutSuccess: true,
            logoutError: null,
            accessToken: null,
            refreshToken: null,
            profileurl: null,
            loginUser: null,
            userRole: null,
            userPermissions: null,
          },
        });
        setTimeout(() => {
          history.push("/login");
        }, 1000);
      });
  };
}

export function resetPassword(pwd, cnf_pwd, email, token) {
  return (dispatch) => {
    let data = {
      userName: email,
      newPassword: pwd,
      otp: token,
    };
    if (pwd !== cnf_pwd) {
      dispatch(
        showAlert({
          isOpen: true,
          title: "error",
          type: "danger",
          msg: "Passwords don't match",
        })
      );
    } else {
      dispatch(showLoader());
      Api.post("auth/password/reset", data)

        .then((response) => {
          // console.log("Reset Response:", response);
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.RESET_PASSWORD,
            payload: {
              resetPassword: true,
            },
          });

          history.push("/login");

          showAlert({
            isOpen: true,
            title: "Success",
            type: "success",
            msg: "Password Reset Successfully",
          });
        })
        .catch((err) => {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.RESET_PASSWORD,
            payload: {
              resetPassword: false,
            },
          });
        });
    }
  };
}

export function forgotPassword(email) {
  return (dispatch) => {
    let data = {
      userName: email,
    };
    Api.post("auth/password/forgot", data)

      .then((response) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.FORGOT_PASSWORD,
          payload: {
            forgotPassword: true,
          },
        });

        history.push(
          "/reset_password?email=" + email + "&token=" + response.data.otp
        );
      })
      .catch((err) => {
        dispatch(hideLoader());
        dispatch({
          type: actionTypes.FORGOT_PASSWORD,
          payload: {
            authPending: false,
            authSuccess: false,
            authError: null,
            accessToken: null,
            refreshToken: null,
            profileurl: null,
            loginUser: null,

            forgotPassword: false,
          },
        });
        dispatch(
          showAlert({
            isOpen: true,
            title: "error",
            type: "danger",
            msg: "Error In Processing Request,",
          })
        );
      });
  };
}

export function changePassword(old_pwd, pwd, cnf_pwd, token, refToken) {
  // export function changePassword(pwd, cnf_pwd, email) {

  return (dispatch) => {
    let data = {
      oldPassword: old_pwd,
      // userName: email,
      newPassword: pwd,
    };
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    if (pwd !== cnf_pwd) {
      dispatch(
        showAlert({
          isOpen: true,
          title: "error",
          type: "danger",
          msg: "Passwords don't match",
        })
      );
    } else {
      dispatch(showLoader());
      dispatch({
        type: actionTypes.CHANGE_PASSWORD_PENDING,
        payload: {
          changePasswordPending: true,
          changePasswordSuccess: false,
          changePasswordError: null,
        },
      });
      console.log("Data headers:", data, headers);

      Api.post("auth/password/change", data, headers)

        .then((response) => {
          // console.log(response);
          if (response.data) {
            dispatch(hideLoader());
            dispatch({
              type: actionTypes.CHANGE_PASSWORD_SUCCESS,
              payload: {
                changePasswordPending: false,
                changePasswordSuccess: true,
                changePasswordError: null,
              },
            });
            dispatch(
              showAlert({
                isOpen: true,
                title: "Success",
                type: "success",
                msg: response.message,
              })
            );
          } else {
            dispatch(hideLoader());
            dispatch(
              showAlert({
                isOpen: true,
                title: "error",
                type: "danger",
                msg: response.message,
              })
            );
          }
        })
        .catch((err) => {
          dispatch(hideLoader());
          dispatch({
            type: actionTypes.CHANGE_PASSWORD_ERROR,
            payload: {
              changePasswordPending: false,
              changePasswordSuccess: true,
              changePasswordError: null,
            },
          });
          dispatch(
            showAlert({
              isOpen: true,
              title: "error",
              type: "danger",
              msg: "Incorrect Old Password",
            })
          );
        });
    }
  };
}

export function updateToken(token, refreshToken) {
  // console.log("test", token, refreshToken);
  return (dispatch) => {
    // console.log(" Update token,refresh ::", token, refreshToken);
    dispatch({
      type: actionTypes.UPDATE_TOKEN_SUCCESS,
      payload: {
        accessToken: token,
        refreshToken: refreshToken,
      },
    });
  };
}

export function resetUserLoginDetails() {
  return (dispatch) => {
    dispatch({
      type: actionTypes.RESET_USER_LOGIN_DETAILS,
      payload: {
        accessToken: null,
        refreshToken: null,
        userRole: null,
        loginUser: null,
      },
    });

    setTimeout(() => {
      history.push("/login");
    }, 500);
  };
}
